<template>
  <div class="coach-rank">
    <!-- <div class="find-more" @click="bindSelectStore">
        <span v-if="curStoreData" class="store">
          <span class="iconfont icon-dingwei"></span>
          <span class="store-name">{{ curStoreData.store_name }}</span>
        </span>
        <span v-else>长沙排行</span>
        <div class="line"></div>
        <div
          ><span class="change-store">切换门店</span
          ><span class="iconfont icon-you"></span
        ></div>
      </div> -->
    <div class="rank-flex">
      <div class="rank-scroll">
        <div style="padding-bottom: 32px">
          <div class="tips"
            >数据每30分钟更新1次，仅供参考，最终结果以活动结束为准</div
          >
          <CoachRank
            :isMember="false"
            :showFocus="false"
            :data="coachRankData"
          ></CoachRank>
          <img
            class="gray-logo"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/105e8b8098652ec924de3cec5ec06d35_wh=390_33.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- 选择门店 -->
    <van-popup
      v-model="showSelectStoreToast"
      position="bottom"
      get-container="body"
    >
      <SelectStore
        :changsha="true"
        :show="showSelectStoreToast"
        @close="bindCloseStore"
        @confirm="bindSelectConfirm"
      />
    </van-popup>
    <AppLoading class="loading" v-if="!loaded" />
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
import CoachRank from './components/coach-rank.vue'
import SelectStore from './components/select-store.vue'
export default {
  components: { CoachRank, SelectStore, AppLoading },
  props: {
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      curStoreData: null,
      showSelectStoreToast: false,
      coachRankData: null,
      loaded: false
    }
  },
  created() {
    this.getData()
  },
  computed: {},
  methods: {
    async getData(storeId) {
      let url = ''
      let params = {}
      if (storeId) {
        params.store_id = storeId
        url = 'api/v1/AnnualCoach/coachRank'
      } else {
        params.city_code = '4301'
        url = 'api/v1/AnnualCoach/allCoachRank'
      }
      let res = await this.$http.getApp(url, params).catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.coachRankData = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async bindSelectConfirm(curStoreDta) {
      this.curStoreData = curStoreDta
      this.getData(curStoreDta.store_id)
      this.bindCloseStore()
    },
    bindCloseStore() {
      this.showSelectStoreToast = false
    },
    bindSelectStore() {
      this.showSelectStoreToast = true
    },
    bindDynamic() {
      this.$emit('dynamic')
    }
  }
}
</script>
<style lang="scss">
.van-popup {
  background-color: transparent;
  overflow-y: visible;
}
</style>
<style lang="scss" scoped>
.coach-rank {
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .loading {
    z-index: 99;
    position: fixed;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
  }
  .find-more {
    padding: 30px 20px 5px;
    font-weight: bold;
    font-size: 14px;
    color: #050b27;
    display: inline-flex;
    align-items: center;
    .store {
      display: flex;
      align-items: center;
    }
    .store-name {
      max-width: 230px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .iconfont {
      font-weight: normal;
      color: rgba(5, 11, 39, 0.3);
      margin-right: 3px;
    }
    .line {
      width: 1px;
      height: 11px;
      background-color: rgba(5, 11, 39, 0.5);
      margin: 0px 5px;
    }
    .change-store {
      font-weight: normal;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 17px;
    }
  }
  .tips {
    padding: 20px 20px 0px;
    font-weight: normal;
    font-size: 12px;
    color: rgba(5, 11, 39, 0.5);
    line-height: 17px;
  }
  .rank-flex {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .rank-scroll {
      height: 100%;
      overflow-y: scroll;
    }
    .page-scorll-disabled {
      overflow-y: hidden;
    }
  }
  .dynamic-btn {
    width: 335px;
    height: 32px;
    background: #f7f7f7;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin: 0 auto;
    color: rgba(5, 11, 39, 0.7);
    line-height: 20px;
  }
  .gray-logo {
    margin: 30px auto 20px;
    width: 130px;
    height: 11px;
    object-fit: contain;
  }
}
</style>
